import { SET_ATTRIBUTE_FIELD } from './actions';

const initialState = {
    selected: '',
    desc: '',
    id: '',
    ifcType: '',
    isSelected: false,
};

export function attributeReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ATTRIBUTE_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
